import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, apiError } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null=loading, false=none, obj=user
  const [token, setToken] = useState(() => localStorage.getItem("bc_token"));

  useEffect(() => {
    if (!token) { setUser(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => { localStorage.removeItem("bc_token"); setToken(null); setUser(false); });
  }, [token]);

  const login = useCallback(async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("bc_token", data.token);
      setToken(data.token);
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) { return { ok: false, error: apiError(e.response?.data?.detail) }; }
  }, []);

  const register = useCallback(async (name, email, password) => {
    try {
      const { data } = await api.post("/auth/register", { name, email, password });
      localStorage.setItem("bc_token", data.token);
      setToken(data.token);
      setUser(data.user);
      return { ok: true, user: data.user };
    } catch (e) { return { ok: false, error: apiError(e.response?.data?.detail) }; }
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("bc_token");
    setToken(null);
    setUser(false);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
